export const transformData = (data) => {
  const transformedServiceTypes = [];
  data.service_types.forEach((serviceType) => {
    if (["workshop", "others"].includes(serviceType)) {
      transformedServiceTypes.push(`${serviceType}_${data.category}`);
    } else {
      transformedServiceTypes.push(serviceType);
    }
  });

  return {
    kinds_of_moment: data.kinds_of_moment,
    category: data.category,
    service_types: transformedServiceTypes,
    country_codes: data.country_codes,
  };
};

export const transformServiceTypes = (serviceTypes) => {
  const result = Object.entries(serviceTypes).reduce(
    (acc, [category, categoryServiceTypes]) => {
      acc[category] = Object.keys(categoryServiceTypes).map((serviceType) => {
        if (["workshop", "others"].includes(serviceType)) {
          return `${serviceType}_${category}`;
        }
        return serviceType;
      });
      return acc;
    },
    {},
  );

  return result;
};

export default {
  transformData,
  transformServiceTypes,
};
